import { PetType } from '@rover/types/src/Pet';

const getIsCatOnlyPetType = (petType: PetType[]): boolean => {
  if (petType.length === 0) {
    return false;
  }
  const uniquePetTypes = new Set(petType);
  return uniquePetTypes.has(PetType.CAT) && uniquePetTypes.size === 1;
};

export default getIsCatOnlyPetType;
